module.exports = __webpack_public_path__ + "static/media/screen-no-preview.5250c327.svg";